import api from './api';

export interface LicenseStatus {
  active: boolean;
  expired?: boolean;
  expiringSoon?: boolean;
  customerName?: string;
  plan?: string;
  expiryDate?: string;
  daysRemaining?: number;
  maxEmployees?: number;
  modules?: string[];
  message?: string;
}

export interface ActivateResponse {
  success: boolean;
  message?: string;
  data?: {
    customerName?: string;
    plan?: string;
    expiryDate?: string;
    maxEmployees?: number;
  };
}

const licenseService = {
  // Backend response: { success, data: {active, expired, expiringSoon, customerName, plan, expiryDate, daysRemaining, maxEmployees, modules} }
  // api.get zaten response.data'yi unwrap ediyor → wrapper.data.active seklinde erisim
  getStatus: async (): Promise<LicenseStatus> => {
    try {
      const res: any = await api.get('/license/status');
      const d = res?.data ?? res;  // bazen unwrap 1 kez bazen 2 kez — her ikisini karsila
      if (d && typeof d.active === 'boolean') return d as LicenseStatus;
      // data icinde data varsa
      if (d?.data && typeof d.data.active === 'boolean') return d.data as LicenseStatus;
      return { active: false, message: 'Lisans bilgisi alinamadi' };
    } catch {
      return { active: false, message: 'Sunucuya erisilemedi' };
    }
  },

  activate: async (licenseKey: string): Promise<ActivateResponse> => {
    try {
      const res: any = await api.post('/license/activate', { licenseKey });
      return {
        success: res?.success ?? false,
        message: res?.message,
        data: res?.data,
      };
    } catch (e: any) {
      return {
        success: false,
        message: e?.response?.data?.message || 'Aktivasyon basarisiz',
      };
    }
  },
};

export default licenseService;
